import { render, staticRenderFns } from "./holidayWageSet.vue?vue&type=template&id=2edb73e4&scoped=true&"
import script from "./holidayWageSet.vue?vue&type=script&lang=js&"
export * from "./holidayWageSet.vue?vue&type=script&lang=js&"
import style0 from "./holidayWageSet.vue?vue&type=style&index=0&id=2edb73e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edb73e4",
  null
  
)

export default component.exports